const n = 6048e5, s = 864e5, o = 6e4, c = 36e5, i = 1e3;
export {
  s as millisecondsInDay,
  c as millisecondsInHour,
  o as millisecondsInMinute,
  i as millisecondsInSecond,
  n as millisecondsInWeek
};
//# sourceMappingURL=constants.js.map
